import React from 'react';

import './popup_3d_secure.css';

const popup_3d_secure = (props) => {
    return (
        <div className="popup_3d_secure">
            <div className="iframe_div">
                <div className="popup_3d_secure_head">Connecting to your Bank...</div>
                <iframe src={props.url}></iframe>
            </div>
        </div>
    );
}

export default popup_3d_secure;